// extracted by mini-css-extract-plugin
module.exports = {"funnelBlockWrapper":"Banner_funnelBlockWrapper__iE4Yp","funnelWrapperClasses":"Banner_funnelWrapperClasses__cqtcH","funnelFunnelClasses":"Banner_funnelFunnelClasses__9OUha"};